import * as React from 'react'
import { useDispatch } from 'redux-react-hook'
import { setPage } from '../../../actions/header.action'
import { getPatientDetails } from '../../../actions/patient.action'
import { Header } from '../../molecules/header/index'
import styled from 'styled-components'
import { Size } from '../../../constants/app.constant'
import Contents from './contents'
import * as HeaderConst from '../../../constants/header.constant'
import useGetState from '../../../hooks/use-get-state'
import useFetchApi from '../../../hooks/use-fetch-api'

const { useEffect } = React

const InquiryForm: React.SFC = () => {
  const dispatch = useDispatch()
  const {
    state: { auth },
  } = useGetState()
  const { isLoading, response } = useFetchApi({
    method: 'GET',
    url: `inquiries/${auth.user.idToken.payload['custom:userId']}`,
  })
  useEffect(
    () => {
      document.title = '新規お問い合わせ画面'
      dispatch(setPage(HeaderConst.HEADER_REPORT))
      dispatch(
        getPatientDetails({
          patientId: auth.user.idToken.payload['custom:userId'],
          jwtToken: auth.user.idToken.jwtToken,
        })
      )
    },
    [auth.user.idToken.jwtToken, auth.user.idToken.payload, dispatch]
  )
  useEffect(
    () => {
      // if (response)
      // dispatch(setInquiries(response))
    },
    [response]
  )
  return (
    !isLoading && (
      <Wrapper>
        <Header />
        <Contents />
      </Wrapper>
    )
  )
}
export default InquiryForm
const Wrapper = styled.div`
  max-width: ${Size.BREAK_POINT.MOBILE}px;
  background: white;
  margin: 0 auto;
`



// WEBPACK FOOTER //
// ./src/components/pages/inquiry_form/inquiry_form.tsx